import { useEffect, useState } from 'react';

import {
  buildCommunityMenuOptions,
  communityMenuOptions as baseCommunityMenuOptions,
} from '../config/configExtras';
import { getCommunityCategories } from '../util/strapiApi';

const useCommunityMenuOptions = () => {
  const [menuOptions, setMenuOptions] = useState(baseCommunityMenuOptions);

  useEffect(() => {
    let active = true;

    getCommunityCategories()
      .then(categories => {
        if (active) {
          setMenuOptions(buildCommunityMenuOptions(categories));
        }
      })
      .catch(() => {
        // Keep the non-category Community links available while Strapi is unavailable.
      });

    return () => {
      active = false;
    };
  }, []);

  return menuOptions;
};

export default useCommunityMenuOptions;
